<template>
  <div>
    <v-container>
        <v-layout   row wrap>
                          <h1>Let's plan a project</h1>

        </v-layout>
      <v-layout   row wrap>
          <v-flex xs12 md6 lg6>
        <h3>Whether you have a new project, looking to improve an existing project or looking for a partner, don’t hesitate to contact us today.</h3>
        <v-form>
          <v-text-field filled label="Email" v-model="contact.email" persistent-hint></v-text-field>
          <v-text-field
            filled
            :label="$t('app.company_name')"
            v-model="contact.company"
            persistent-hint
          ></v-text-field>
          <v-textarea filled label="Anything Else to Tell Us" v-model="contact.content"></v-textarea>
          <v-btn class="blue lighten-2 mb-5" dark large>{{$t('app.get_in_touch')}}</v-btn>
        </v-form>
        </v-flex>
          <v-flex xs12 md6 lg6 class="pa--10">
              <h3>Other Info</h3>
              <p>Cité des fréres achouri</p>
              <p>Dar El Beida</p>
              <p>16033</p>
              <P>Alger</P>
          </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "Contact",
  components: {},
  data() {
    return {
      contact: {}
    };
  },
  methods: {}
};
</script>

<style scoped>
</style>